export const INITIAL_LOADING_TEXT = 'Loading course data...'
export const DEFAULT_UNIT = 'unit-1'
export const CORE_UNITS_LABEL = 'Core'
export const BULLYING_UNITS_LABEL = 'Recognizing Bullying & Harassment'
export const COURSE_LEVEL_CONTENT_QUERY_TYPE = 'courseLevelContent'
export const MILISECONDS_BEFORE_REFRESH = 5000
